import { render, staticRenderFns } from "./DocumentsTender.vue?vue&type=template&id=6f6e0a07&"
import script from "./DocumentsTender.vue?vue&type=script&lang=js&"
export * from "./DocumentsTender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports